import { WorkCoreBase } from "./work.core.base"


export class WorkCore extends WorkCoreBase {

}